export default __webpack_public_path__ + "paddle_securitya13844.svg";